export default __webpack_public_path__ + "static/N0233-e16b6ca8aef30962a4c2a2e8e5a4a70d.png";